export const VerticalDivider = () => (
  <div className="t-w-[1px] t-h-[0.9rem] t-bg-neutral-20"></div>
);
